module.exports = __webpack_public_path__ + "img/pantalla-3-6.78999a18.png";